import React, { useState, useEffect, useRef } from 'react';
import axios from '../../hooks/fetchWithAuth';
import { TextField, Button, IconButton, Box, Checkbox, List, ListItem, ListItemText, Card, CardContent, Divider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import LinearProgress from '@mui/material/LinearProgress';
import { Span, Flex } from "../../style";
import ChecklistIcon from '@mui/icons-material/Checklist';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Checklist from '../Checklist';
import config from '../../config';
import ConfirmationDialog from '../Confirmation';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import EditIcon from '@mui/icons-material/Edit';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import './Checklist.css';
import getCookie from '../../hooks/getCookie';
import AddTaskIcon from '@mui/icons-material/AddTask';
import CheckIcon from '@mui/icons-material/Check';
import Alerts from '../Alert2/index';
import ReactDOM from "react-dom";

export default function Checklist2({ selectedCard, todos, setTodos, handleLogs, onChecklistUpdate }) {
  const [checklists, setChecklists] = useState([]);
  const [items, setItems] = useState({});
  const [newTasks, setNewTasks] = useState({});
  const [progress, setProgress] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentChecklist, setCurrentChecklist] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const editRef = useRef(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpenTask, setDialogOpenTask] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [checklistToDelete, setChecklistToDelete] = useState(null);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [editingTaskText, setEditingTaskText] = useState('');
  const [subTasks, setSubTasks] = useState({});
  const [editingSubtaskText, setEditingSubtaskText] = useState('');
  const [subtaskAnchorEl, setSubtaskAnchorEl] = useState(null);
  const [currentSubtaskId, setCurrentSubtaskId] = useState(null);
  const [editingSubtaskId, setEditingSubtaskId] = useState(null);
  const [isEditingSubTask, setIsEditingSubTask] = useState(false);
  const [deleteSubtask, setDeleteSubtask] = useState(false);
  const [subTaskToDelete, setSubTaskToDelete] = useState(null);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [completedTasks, setCompletedTasks] = React.useState(0);
  const [subTasksProgress, setSubTasksProgress] = useState({});

  // ip do backend
  const backendIp = config.backend_ip;
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const sessionId = getCookie("session_id");

  const [alert, setAlert] = React.useState({
    show: false,
    severity: '',
    message: ''
  });
  const showAlert = (severity, message) => {
    setAlert({ show: true, severity, message });
    setTimeout(() => {
      setAlert({ show: false, severity: '', message: '' });
    }, 3000);
  };

  // Effect para acionar o fetch quando uma nova checklist for adicionada
  useEffect(() => {
    if (todos !== null) {
      fetchChecklists();
      setTodos(null);
    }
  }, [todos]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (editRef.current && !editRef.current.contains(event.target)) {
        setIsEditing(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editRef]);

  const DemoPaper = styled(Paper)(({ theme }) => ({
    width: 120,
    height: 40,
    ...theme.typography.body2,
    textAlign: 'center',
    backgroundColor: '#f8fafc',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    color: '#374151',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px'
  }));

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleTitleChange = (event) => {
    setNewTitle(event.target.value);
  };

  const handleTimeClick = (taskId, event) => {
    setSelectedTaskId(taskId);
    setPopoverAnchor(event.currentTarget);
  };

  const handleTimeClose = () => {
    setPopoverAnchor(null);
  };


  const openTime = Boolean(popoverAnchor);
  const id = openTime ? 'simple-popover' : undefined;

  const handleTitleSubmit = async () => {
    if (!newTitle.trim()) {
      setIsEditing(false);
      handlePopoverClose();
      return;
    }

    try {
      const response = await axios.put(`${backendIp}/api/board/ti/update_checklist`, {
        id_checklist: currentChecklist,
        checklist_title: newTitle,
        user: username,
        sesion_id: sessionId
      });
      showAlert('success', 'Checklist editada com sucesso!');
      fetchChecklists();
    } catch (error) {
      showAlert('error', 'Erro ao editar checklist.');
    }
    setIsEditing(false);
    handlePopoverClose();
  };

  const handleDateSubmit = async () => {
    const formattedDate = selectedDate.toISOString(); // Converte para formato ISO 8601
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_date`, {
        task_id: selectedTaskId,
        data_expiracao: formattedDate,
        user: username,
        session_id: sessionId
      });
      fetchChecklists();
      handleTimeClose();
    } catch (error) {
      showAlert('error', 'Erro ao adicionar data na task.');
    }
  };

  const handleDataRemove = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/update_date_task`, {
        task_id: selectedTaskId,
        session_id: sessionId,
        user: username
      });
      fetchChecklists();
      handleTimeClose();
    } catch (error) {
      showAlert('error', 'Erro ao atualizar a tarefa.');
    }
  };

  const handlePopoverOpen = (event, checklistId) => {
    setAnchorEl(event.currentTarget);
    setCurrentChecklist(checklistId);
    setNewTitle(checklists.find(checklist => checklist.id_checklist === checklistId)?.checklist_title || ''); // Define o título atual para edição
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCurrentChecklist(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (selectedCard.id) {
      fetchChecklists();
    }
  }, [selectedCard.id]);

  useEffect(() => {
    calculateProgress();
  }, [items, subTasks]);

  const fetchChecklists = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_checklist`, {
        card_id: selectedCard.id,
        user: username,
        session_id: sessionId
      });

      const checklists = response.data;
      setChecklists(checklists);

      checklists.forEach(async (checklist) => {
        // Busca das tarefas principais
        const tasksResponse = await axios.get(`${backendIp}/api/board/ti/list_task_in_checklist/${checklist.id_checklist}`);
        const tasks = tasksResponse.data.tasks;

        // Atualiza o estado com as tasks
        setItems((prevItems) => ({ ...prevItems, [checklist.id_checklist]: tasks }));
        setProgress((prevProgress) => ({ ...prevProgress, [checklist.id_checklist]: calculateChecklistProgress(tasks) }));

        // Agora, para cada tarefa, busca as subtasks
        tasks.forEach(async (task) => {
          try {
            const subtasksResponse = await axios.get(`${backendIp}/api/board/ti/list_subtask_in_checklist/${task.task_id}`);
            const subtasks = subtasksResponse.data.subtasks;
            setSubTasks((prevSubTasks) => ({
              ...prevSubTasks,
              [task.task_id]: subtasks,
            }));
          } catch (error) {
            showAlert('error', 'Erro ao buscar subtasks para task.');
          }
        });
      });
    } catch (error) {
      showAlert('error', 'Erro ao listar checklists.');
    }
  };

  const calculateProgress = () => {
    Object.keys(items).forEach((checklistId) => {
      setProgress((prevProgress) => ({
        ...prevProgress,
        [checklistId]: calculateChecklistProgress(items[checklistId]),
      }));
    });
  };
  const handleDeleteItem = async (checklistId, task_id) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/remove_task`, {
        task_id: task_id,
        session_id: sessionId,
        user: username
      });
      setDialogOpenTask(false);
      const deletedItem = items[checklistId].find(item => item.task_id === task_id);
      const updatedItems = items[checklistId].filter(item => item.task_id !== task_id);
      setItems((prevItems) => ({ ...prevItems, [checklistId]: updatedItems }));
      if (deletedItem && deletedItem.completed) {
        setCompletedTasks((prevCompleted) => prevCompleted - 1);
      }
      showAlert('success', 'Tarefa excluída com sucesso!');
    } catch (error) {
      setDialogOpenTask(false);
      showAlert('error', 'Erro ao deletar tarefa.');
    }
  };

  const handleDeleteChecklist = async (id_checklist) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/delete_checklist`, {
        id_checklist: id_checklist,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });
      setDialogOpen(false);
      handleLogs();

      setChecklists((prevChecklists) => prevChecklists.filter(checklist => checklist.id_checklist !== id_checklist));
      setItems((prevItems) => {
        const updatedItems = { ...prevItems };
        delete updatedItems[id_checklist];
        return updatedItems;
      });
      showAlert('success', 'Checklist excluída com sucesso!');
    } catch (error) {
      showAlert('error', 'Erro ao excluir checklist.');
    }
  };

  const handleToggleComplete = async (checklistId, index) => {
    const item = items[checklistId][index];
    const newCompletedState = !item.completed;
    const updatedItems = items[checklistId].map((t, i) =>
      i === index ? { ...t, completed: newCompletedState } : t
    );
    const updatedSubTasksForTask = (subTasks[item.task_id] || []).map((subtask) => ({
      ...subtask,
      completed: newCompletedState,
    }));
    setItems((prevItems) => ({ ...prevItems, [checklistId]: updatedItems }));
    setSubTasks((prevSubTasks) => ({
      ...prevSubTasks,
      [item.task_id]: updatedSubTasksForTask,
    }));
    try {
      await axios.put(`${backendIp}/api/board/ti/update_task/${item.task_id}`, {
        completed: newCompletedState,
        user: username,
        name_complete: username,
      });
      const updateSubtaskPromises = updatedSubTasksForTask.map((subtask) =>
        axios.put(`${backendIp}/api/board/ti/update_subtask/${subtask.subtask_id}`, {
          completed: newCompletedState,
          user: username,
          name_complete: username,
        })
      );
      await Promise.all(updateSubtaskPromises);
      await fetchSubTasksProgress();
      showAlert('success', 'Status atualizado com sucesso!');

    } catch (error) {
      showAlert('error', 'Erro ao atualizar status!');
    }
  };

  const handleToggleSubtaskComplete = async (taskId, subtaskIndex, checklistId) => {
    const currentSubtasks = subTasks[taskId] || [];
    if (subtaskIndex < 0 || subtaskIndex >= currentSubtasks.length) {
      return;
    }
    const subtaskToUpdate = currentSubtasks[subtaskIndex];
    const newCompletedState = !subtaskToUpdate.completed;
    const updatedSubtasksForTask = currentSubtasks.map((st, i) =>
      i === subtaskIndex ? { ...st, completed: newCompletedState } : st
    );
    setSubTasks((prevSubTasks) => ({
      ...prevSubTasks,
      [taskId]: updatedSubtasksForTask,
    }));
    const allSubtasksCompleted = updatedSubtasksForTask.every((st) => st.completed);
    const taskItem = items[checklistId].find((t) => t.task_id === taskId);
    if (taskItem && allSubtasksCompleted !== taskItem.completed) {
      setItems((prevItems) => ({
        ...prevItems,
        [checklistId]: prevItems[checklistId].map((t) =>
          t.task_id === taskId ? { ...t, completed: allSubtasksCompleted } : t
        ),
      }));
    }
    try {
      await axios.put(
        `${backendIp}/api/board/ti/update_subtask/${subtaskToUpdate.subtask_id}`,
        {
          completed: newCompletedState,
          user: username,
          name_complete: username,
        }
      );
      if (taskItem && allSubtasksCompleted !== taskItem.completed) {
        await axios.put(
          `${backendIp}/api/board/ti/update_task/${taskId}`,
          {
            completed: allSubtasksCompleted,
            user: username,
            name_complete: username,
          }
        );
      }
      await fetchSubTasksProgress();
      showAlert('success', 'Status atualizado com sucesso!');
    } catch (error) {
      showAlert('error', 'Erro ao atualizar status!');
    }
  };

  const calculateChecklistProgress = (tasks) => {
    if (!tasks || tasks.length === 0) return 0;
    let totalContableItems = 0;
    let completedContableItems = 0;
    tasks.forEach(task => {
      const taskSubtasks = subTasks[task.task_id] || [];
      if (taskSubtasks.length === 0) {
        totalContableItems++;
        if (task.completed) {
          completedContableItems++;
        }
      } else {
        taskSubtasks.forEach(subtask => {
          totalContableItems++;
          if (subtask.completed) {
            completedContableItems++;
          }
        });
      }
    });

    if (totalContableItems === 0) return 0;
    return (completedContableItems / totalContableItems) * 100;
  };

  const handleAddTask = async (task_text, checklistId) => {
    if (!task_text?.trim()) return;
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_task`, {
        card_id: selectedCard.id,
        task_text: task_text,
        checklist_id: checklistId,
        user: username,
        session_id: sessionId
      });
      const newTaskItem = response.data;
      setItems((prevItems) => ({
        ...prevItems,
        [checklistId]: [...prevItems[checklistId], {
          task_id: newTaskItem.task_id,
          task_text: task_text,
          completed: false
        }]
      }));
      setNewTasks((prevTasks) => ({ ...prevTasks, [checklistId]: '' }));
      fetchChecklists();
      showAlert('success', 'Tarefa adicionada com sucesso!');
    } catch (error) {
      showAlert('error', 'Erro ao adicionar tarefa.');
    }
  };

  // FUNÇÕES PARA SUBTAREFAS --------------------------------------------------------------
  const handleAddSubTask = (taskId) => {
    const tempSubtaskId = `new-subtask-${Date.now()}`;
    const newSubTask = {
      subtask_id: tempSubtaskId,
      subtask_text: "",
      completed: false,
    };
    setSubTasks((prevSubTasks) => ({
      ...prevSubTasks,
      [taskId]: [...(prevSubTasks[taskId] || []), newSubTask],
    }));
    setIsEditingSubTask(true);
    setEditingSubtaskId(tempSubtaskId);
    setEditingSubtaskText("");
  };

  const handleSaveSubTask = async (taskId, checklistId) => {
    const trimmedText = editingSubtaskText.trim();
    if (!trimmedText) return;
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_subtask`, {
        task_id: taskId,
        subtask_text: trimmedText,
        checklist_id: checklistId,
        user: username,
        session_id: sessionId,
      });

      const newSubtaskFromDB = {
        subTask_id: response.data.subtask_id,
        subTask_text: trimmedText,
        completed: false,
      };

      setSubTasks((prevSubTasks) => {
        const updated = {
          ...prevSubTasks,
          [taskId]: prevSubTasks[taskId].map((subtask) =>
            subtask.subTask_id === editingSubtaskId ? newSubtaskFromDB : subtask
          ),
        };
        return updated;
      });

      setEditingSubtaskId(null);
      setEditingSubtaskText('');
      fetchChecklists();
      await fetchSubTasksProgress();
      showAlert('success', 'Subtarefa salva com sucesso!');
    } catch (error) {
      showAlert('error', 'Subtarefa não pode ser adicionada, verifique as informações!');
    }
  };

  const handleEditSubtaskSubmit = async (taskId, subtaskId, subtaskText) => {
    if (!taskId || !subtaskId || !subtaskText?.trim()) {
      showAlert('error', 'Parâmetros inválidos para edição');
      return;
    }

    try {
      await axios.put(`${backendIp}/api/board/ti/edit_subtask`, {
        task_id: taskId,
        subtask_id: subtaskId,
        subtask_text: subtaskText.trim(),
        user: username,
        session_id: sessionId
      });
      setSubTasks(prev => ({
        ...prev,
        [taskId]: prev[taskId].map(st =>
          st.subtask_id === subtaskId
            ? { ...st, subtask_text: subtaskText.trim() }
            : st
        )
      }));
      setIsEditingSubTask(false);
      setEditingSubtaskId(null);
      setEditingSubtaskText('');
      showAlert('success', 'Subtarefa editada com sucesso!');
    } catch (error) {
      showAlert('error', 'Erro ao editar subtarefa.');

    }
  };

  const handleSubtaskOptionsClose = () => {
    setSubtaskAnchorEl(null);
    setCurrentSubtaskId(null);
  };

  const handleSubtaskOptionsOpen = (event, subtaskId, taskId) => {
    event.stopPropagation();
    setSubtaskAnchorEl(event.currentTarget);
    setCurrentSubtaskId(subtaskId);
    setCurrentTaskId(taskId);
  };

  const handleDeleteSubtask = async (task_id, subtask_id) => {
    try {
      await axios.delete(`${backendIp}/api/board/ti/remove_subtask`, {
        data: {
          subtask_id: subtask_id,
          user: username,
          session_id: sessionId
        }
      });
      setDeleteSubtask(false);
      setSubtaskAnchorEl(null);
      setSubTasks((prevSubTasks) => {
        const updatedSubTasks = { ...prevSubTasks };
        if (updatedSubTasks[task_id]) {
          updatedSubTasks[task_id] = updatedSubTasks[task_id].filter(subtask => subtask.subtask_id !== subtask_id);
        }
        return updatedSubTasks;
      });
      showAlert('success', 'Subtarefa excluída com sucesso!');
      fetchChecklists();
    } catch (error) {
      setDeleteSubtask(false);
      showAlert('error', 'Erro ao remover subtarefa.');
    }
  };
  const fetchSubTasksProgress = async () => {
    try {
      const response = await axios.get(`${backendIp}/api/board/ti/list_subtasks_progress`);
      const progressData = {};
      response.data.forEach((item) => {
        progressData[item.task_id] = {
          total: item.total_subtasks,
          completed: item.completed_subtasks
        };
      });
      setSubTasksProgress(progressData);
    } catch (error) {
      showAlert('error', 'Erro ao buscar progresso das subtarefas.');
    }
  };
  useEffect(() => {
    fetchSubTasksProgress();
  }, []);

  const openDeleteSubtask = (subtask) => {
    setSubTaskToDelete(subtask); 
    setDeleteSubtask(true);      
  };
  const openSubtaskOptions = Boolean(subtaskAnchorEl);
  const subtaskPopoverId = openSubtaskOptions ? 'subtask-options-popover' : undefined;
  // FIM DAS FUNÇÕES PARA SUBTAREFAS --------------------------------------------------------------

  const handleEditTaskClick = (taskId, taskText) => {
    setEditingTaskId(taskId);
    setEditingTaskText(taskText);
  };

  const handleEditTaskChange = (event) => {
    setEditingTaskText(event.target.value);
  };

  const handleEditTaskSubmit = async () => {
    if (!editingTaskText.trim()) return;

    try {
      await axios.put(`${backendIp}/api/board/ti/edit_task`, {
        task_id: editingTaskId,
        task_text: editingTaskText
      });
      fetchChecklists();
      setEditingTaskId(null);
      setEditingTaskText('');
      showAlert('success', 'Tarefa editada com sucesso!');
    } catch (error) {
      showAlert('error', 'Erro ao editar tarefa.');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Verifica se a data é nula ou indefinida

    const months = [
      'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
      'jul', 'ago', 'set', 'out', 'nov', 'dez'
    ];

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // Verifica se a data é inválida

    const today = new Date();
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const currentYear = today.getUTCFullYear();

    // Checa se a data é hoje, no passado ou no futuro
    if (date.toDateString() === today.toDateString()) {
      return `${day} de ${month}`;
    } else if (date.getUTCFullYear() === currentYear) {
      // Data no passado ou futuro, mas no ano atual
      return `${day} de ${month}`;
    } else {
      // Data no passado ou futuro, e em um ano diferente
      return `${day} de ${month} ${year}`;
    }
  };

  const getDateStyle = (dateString, completed) => {
    if (!dateString) return { color: '#8b9399' }; // Verifica se a data é nula ou indefinida

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return { color: '#8b9399' }; // Verifica se a data é inválida

    const today = new Date();

    if (completed) {
      return { backgroundColor: '#4bce97', color: '#282a29' };
    } else if (date.toDateString() === today.toDateString()) {
      return { backgroundColor: '#f5cd47', color: '#393729' };
    } else if (date < today) {
      return { backgroundColor: '#42221f', color: '#bc4942' };
    } else {
      return { backgroundColor: '#3a444c', color: '#8b9399' };
    }
  };

  const handleMoveTask = async (checklistId, index, direction) => {
    const updatedItems = Array.from(items[checklistId]);
    const [movedItem] = updatedItems.splice(index, 1);
    updatedItems.splice(index + direction, 0, movedItem);

    setItems((prevItems) => ({
      ...prevItems,
      [checklistId]: updatedItems,
    }));

    try {
      await axios.put(`${backendIp}/api/board/ti/update_task_order`, {
        checklist_id: checklistId,
        session_id: sessionId,
        user: username,
        tasks: updatedItems.map((item, index) => ({
          task_id: item.task_id,
          order: index,
        })),
      });
    } catch (error) {
      showAlert('error', 'Erro ao atualizar a ordem das tarefas.');
    }
  };

  return (
    <>
      <Box sx={{ width: '100%', bgcolor: 'transparent', border: 'none' }}>
        {checklists.map((checklist) => (
          <Card key={checklist.id_checklist} className="checklist-card">
            <CardContent className="checklist-card-content">
              <Box className="checklist-header">
                <Box className="checklist-title-section">
                  <ChecklistIcon className="checklist-icon" />
                  <Typography variant="h6" className="checklist-title">
                    {checklist.checklist_title}
                  </Typography>
                </Box>
                <IconButton 
                  className="checklist-menu-button"
                  onClick={(event) => handlePopoverOpen(event, checklist.id_checklist)}
                >
                  <MoreVertIcon />
                </IconButton>
              </Box>

              <Box className="progress-section">
                <Typography className="progress-text">
                  {`${Math.round(progress[checklist.id_checklist] || 0)}%`}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={progress[checklist.id_checklist] || 0}
                  className="progress-bar"
                />
              </Box>

              <Divider className="section-divider" />

              <List className="tasks-list">
                {(items[checklist.id_checklist] || []).map((item, index) => (
                  <Box key={item.task_id} className="task-container">
                    <ListItem className="task-item">
                      <Box className="task-content">
                        <Box className="task-left-section">
                          {editingTaskId !== item.task_id && (
                            <Checkbox
                              checked={item.completed}
                              onChange={() => handleToggleComplete(checklist.id_checklist, index)}
                              className="task-checkbox"
                            />
                          )}
                          
                          {editingTaskId === item.task_id ? (
                            <Box className="task-edit-section">
                              <TextField
                                value={editingTaskText}
                                onChange={handleEditTaskChange}
                                onBlur={handleEditTaskSubmit}
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') {
                                    handleEditTaskSubmit();
                                    e.preventDefault();
                                  }
                                }}
                                variant="outlined"
                                size="small"
                                className="task-edit-input"
                              />
                              <IconButton onClick={handleEditTaskSubmit} className="save-edit-button">
                                <CheckRoundedIcon />
                              </IconButton>
                            </Box>
                          ) : (
                            <Typography 
                              className={`task-text ${item.completed ? 'task-completed' : ''}`}
                            >
                              {item.task_text}
                            </Typography>
                          )}
                        </Box>

                        <Box className="task-actions">
                          {item.data_expiracao && (
                            <Box 
                              className={`due-date-badge ${item.completed ? 'completed' : getDateColorClass(item.data_expiracao)}`}
                              onClick={(event) => handleTimeClick(item.task_id, event)}
                            >
                              <AccessTimeIcon className="due-date-icon" />
                              <Typography className="due-date-text">
                                {formatDate(item.data_expiracao)}
                              </Typography>
                            </Box>
                          )}
                          
                          <IconButton 
                            className="task-menu-button"
                            onClick={(event) => {
                              event.stopPropagation();
                              setSubtaskAnchorEl(event.currentTarget);
                              setCurrentSubtaskId(item.task_id);
                              setCurrentTaskId(item.task_id);
                              setSubTaskToDelete({
                                task_id: item.task_id,
                                subtask_text: item.task_text,
                                isMainTask: true,
                                checklistId: checklist.id_checklist
                              });
                            }}
                            title="Opções da tarefa"
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </ListItem>

                    {subTasks[item.task_id]?.map((subtask, idx) => (
                      <Box key={subtask.subtask_id} className="subtask-container">
                        {isEditingSubTask && subtask.subtask_id === editingSubtaskId ? (
                          <Box className="subtask-edit-section">
                            <TextField
                              value={editingSubtaskText}
                              onChange={(e) => setEditingSubtaskText(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  if (editingSubtaskText.trim()) {
                                    if (String(subtask.subtask_id).startsWith("new-subtask")) {
                                      handleSaveSubTask(item.task_id, checklist.id_checklist);
                                    } else {
                                      handleEditSubtaskSubmit(item.task_id, subtask.subtask_id, editingSubtaskText);
                                    }
                                  }
                                }
                              }}
                              variant="outlined"
                              size="small"
                              autoFocus
                              fullWidth
                              className="subtask-edit-input"
                            />
                            <IconButton
                              onClick={() => {
                                if (editingSubtaskText.trim()) {
                                  if (String(subtask.subtask_id).startsWith("new-subtask")) {
                                    handleSaveSubTask(item.task_id, checklist.id_checklist);
                                  } else {
                                    handleEditSubtaskSubmit(item.task_id, subtask.subtask_id, editingSubtaskText);
                                  }
                                }
                              }}
                              className="subtask-save-button"
                            >
                              <CheckIcon />
                            </IconButton>
                          </Box>
                        ) : (
                          <Box className="subtask-content">
                            <Checkbox
                              checked={subtask.completed}
                              onChange={() => handleToggleSubtaskComplete(item.task_id, idx, checklist.id_checklist)}
                              size="small"
                              className="subtask-checkbox"
                            />
                            <Typography 
                              className={`subtask-text ${subtask.completed ? 'subtask-completed' : ''}`}
                            >
                              {subtask.subtask_text}
                            </Typography>
                            {editingSubtaskId !== subtask.subtask_id && (
                              <IconButton
                                onClick={(event) => {
                                  handleSubtaskOptionsOpen(event, subtask.subtask_id, item.task_id);
                                  setSubTaskToDelete(subtask);
                                }}
                                className="subtask-menu-button"
                              >
                                <MoreVertIcon />
                              </IconButton>
                            )}
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                ))}
              </List>

              <Box className="add-task-section">
                <TextField
                  value={newTasks[checklist.id_checklist] || ''}
                  onChange={(e) => setNewTasks({ ...newTasks, [checklist.id_checklist]: e.target.value })}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && newTasks[checklist.id_checklist]?.trim()) {
                      handleAddTask(newTasks[checklist.id_checklist], checklist.id_checklist);
                      e.preventDefault();
                    }
                  }}
                  placeholder="Adicionar nova tarefa..."
                  variant="outlined"
                  size="small"
                  className="add-task-input"
                />
                <Button
                  onClick={() => handleAddTask(newTasks[checklist.id_checklist], checklist.id_checklist)}
                  className="add-task-button"
                  disabled={!newTasks[checklist.id_checklist]?.trim()}
                >
                  Adicionar
                </Button>
              </Box>
            </CardContent>
          </Card>
        ))}

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {
              backgroundColor: 'var(--bg-secondary, #ffffff)',
              border: '1px solid var(--border-color, #e1e5e9)',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              minWidth: '180px',
              overflow: 'hidden',
            },
          }}
        >
          {isEditing ? (
            <Box sx={{ p: 2, maxWidth: '240px' }} ref={editRef}>
              <Typography sx={{ 
                fontSize: '14px', 
                fontWeight: 600, 
                color: 'var(--text-primary, #172b4d)', 
                mb: 1.5,
                textAlign: 'center'
              }}>
                Editar Checklist
              </Typography>
              <TextField
                value={newTitle}
                onChange={handleTitleChange}
                placeholder="Novo título"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  mb: 1.5,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    '& fieldset': {
                      borderColor: 'var(--border-color, #dfe1e6)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'var(--primary-color, #009373)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'var(--primary-color, #009373)',
                      borderWidth: '2px',
                    },
                  },
                  '& .MuiInputBase-input': {
                    color: 'var(--text-primary, #009373)',
                    padding: '8px 10px',
                  },
                }}
              />
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="contained"
                  onClick={handleTitleSubmit}
                  className="button-popover-green"
                  sx={{
                    flex: 1,
                    fontSize: '13px',
                    fontWeight: 600,
                    textTransform: 'none',
                    borderRadius: '6px',
                    padding: '6px 12px',
                  }}
                >
                  Salvar
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setIsEditing(false)}
                  className="button-cancel-popover"
                  sx={{
                    flex: 1,
                    fontSize: '13px',
                    fontWeight: 600,
                    textTransform: 'none',
                    borderRadius: '6px',
                    padding: '6px 12px',
                  }}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          ) : (
            <Box sx={{ py: 0.5 }}>
              <Typography
                sx={{
                  px: 2,
                  py: 1.5,
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--text-primary, #172b4d)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  '&:hover': {
                    backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                  },
                  transition: 'background-color 0.2s ease',
                }}
                onClick={(event) => handleEditClick(event)}
              >
                <EditIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                Editar Checklist
              </Typography>
              <Typography
                sx={{
                  px: 2,
                  py: 1.5,
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--danger-color, #b04632)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  '&:hover': {
                    backgroundColor: 'var(--danger-bg, #ffebe6)',
                  },
                  transition: 'background-color 0.2s ease',
                }}
                onClick={() => setDialogOpen(true)}
              >
                <DeleteIcon sx={{ fontSize: '16px', color: 'var(--danger-color, #b04632)' }} />
                Excluir Checklist
              </Typography>
            </Box>
          )}
        </Popover>

        <ConfirmationDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onConfirm={() => {
            handleDeleteChecklist(currentChecklist);
            handlePopoverClose();
          }}
          title="Confirmar Exclusão"
          message="Tem certeza de que deseja excluir o checklist? Esta ação não pode ser desfeita."
        />

        <ConfirmationDialog
          open={dialogOpenTask}
          onClose={() => setDialogOpenTask(false)}
          onConfirm={() => {
            handleDeleteItem(checklistToDelete, taskToDelete);
            setChecklistToDelete(null);
            setTaskToDelete(null);
          }}
          title="Confirmar Exclusão"
          message="Tem certeza de que deseja excluir a tarefa? Esta ação não pode ser desfeita."
        />

        <Popover
          id={id}
          open={openTime}
          anchorEl={popoverAnchor}
          onClose={handleTimeClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={{
            sx: {
              backgroundColor: 'var(--bg-secondary, #ffffff)',
              borderRadius: '12px',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
              border: '1px solid var(--border-color, #e1e5e9)',
              overflow: 'hidden',
              maxWidth: '320px',
            }
          }}
        >
          <Box sx={{ 
            backgroundColor: 'var(--bg-tertiary, #f4f5f7)', 
            padding: '16px 20px 12px 20px',
            borderBottom: '1px solid var(--border-color, #e1e5e9)'
          }}>
            <Typography sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: 'var(--text-primary, #172b4d)',
              textAlign: 'center',
              margin: 0,
            }}>
              Definir prazo
            </Typography>
          </Box>
          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              sx={{
                width: '100%',
                padding: '12px',
                '& .MuiPickersCalendarHeader-root': {
                  padding: '0 0 12px 0',
                  margin: 0,
                },
                '& .MuiPickersCalendarHeader-label': {
                  fontSize: '15px',
                  fontWeight: 600,
                  color: 'var(--text-primary, #172b4d)',
                },
                '& .MuiPickersArrowSwitcher-root': {
                  '& .MuiIconButton-root': {
                    backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    color: 'var(--text-secondary, #6b778c)',
                    '&:hover': {
                      backgroundColor: 'var(--bg-hover, #e4e6ea)',
                    }
                  }
                },
                '& .MuiDayCalendar-header': {
                  '& .MuiTypography-root': {
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--text-secondary, #6b778c)',
                    textTransform: 'uppercase'
                  }
                },
                '& .MuiPickersDay-root': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--text-primary, #172b4d)',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: 'var(--bg-hover, #e4e6ea)',
                  }
                },
                '& .MuiPickersDay-root.Mui-selected': {
                  backgroundColor: 'var(--primary-color, #0079bf) !important',
                  color: '#ffffff',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: 'var(--primary-hover, #005a8b) !important',
                  }
                },
                '& .MuiPickersDay-dayOutsideMonth': {
                  color: 'var(--text-disabled, #a5adba)',
                },
                '& .MuiPickersDay-today': {
                  border: '2px solid var(--primary-color, #0079bf) !important',
                  backgroundColor: 'transparent',
                  color: 'var(--primary-color, #0079bf)',
                  fontWeight: 600,
                  '&.Mui-selected': {
                    backgroundColor: 'var(--primary-color, #0079bf) !important',
                    color: '#ffffff',
                  }
                }
              }}
              showDaysOutsideCurrentMonth
              fixedWeekNumber={6}
              onChange={(newValue) => setSelectedDate(newValue)}
            />
          </LocalizationProvider>
          
          <Box sx={{ 
            padding: '12px 20px',
            backgroundColor: 'var(--bg-quaternary, #f8f9fa)',
            borderTop: '1px solid var(--border-color, #e1e5e9)'
          }}>
            <Typography sx={{
              fontSize: '11px',
              fontWeight: 600,
              color: 'var(--text-secondary, #6b778c)',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Data selecionada:
            </Typography>
            <Box sx={{
              backgroundColor: 'var(--bg-secondary, #ffffff)',
              border: '1px solid var(--border-color, #e1e5e9)',
              borderRadius: '6px',
              padding: '6px 10px',
              textAlign: 'center',
              fontSize: '13px',
              fontWeight: 500,
              color: selectedDate ? 'var(--text-primary, #172b4d)' : 'var(--text-secondary, #6b778c)',
              marginBottom: '12px'
            }}>
              {selectedDate ? selectedDate.format('DD/MM/YYYY') : 'Nenhuma data selecionada'}
            </Box>
            
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Button
                variant="outlined"
                onClick={() => handleDataRemove()}
                sx={{
                  flex: 1,
                  borderColor: 'var(--border-color, #dfe1e6)',
                  color: 'var(--text-secondary, #6b778c)',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'none',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  '&:hover': {
                    borderColor: 'var(--danger-color, #b04632)',
                    color: 'var(--danger-color, #b04632)',
                    backgroundColor: 'var(--danger-bg, #ffebe6)',
                  },
                }}
              >
                Remover
              </Button>
              <Button
                variant="contained"
                onClick={() => handleDateSubmit()}
                disabled={!selectedDate}
                className="button-popover-green"
                sx={{
                  flex: 1,
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'none',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  '&:disabled': {
                    backgroundColor: '#b7b7b7',
                    color: '#fff',
                  }
                }}
              >
                Definir
              </Button>
            </Box>
          </Box>
        </Popover>

        <Popover
          id={subtaskPopoverId}
          open={openSubtaskOptions}
          anchorEl={subtaskAnchorEl}
          onClose={handleSubtaskOptionsClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              backgroundColor: 'var(--bg-secondary, #ffffff)',
              border: '1px solid var(--border-color, #e1e5e9)',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              minWidth: '160px',
              overflow: 'hidden',
            }
          }}
        >
          <Box sx={{ py: 0.5 }}>
            {subTaskToDelete?.isMainTask ? (
              <>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--text-primary, #172b4d)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditTaskClick(currentSubtaskId, subTaskToDelete.subtask_text);
                    handleSubtaskOptionsClose();
                  }}
                >
                  <EditIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                  Editar tarefa
                </Typography>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--text-primary, #172b4d)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTimeClick(currentSubtaskId, e);
                    handleSubtaskOptionsClose();
                  }}
                >
                  <AccessTimeIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                  Definir prazo
                </Typography>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--text-primary, #172b4d)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddSubTask(currentSubtaskId);
                    handleSubtaskOptionsClose();
                  }}
                >
                  <AddTaskIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                  Adicionar subtarefa
                </Typography>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--danger-color, #b04632)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--danger-bg, #ffebe6)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={() => {
                    setTaskToDelete(subTaskToDelete.task_id);
                    setChecklistToDelete(subTaskToDelete.checklistId);
                    setDialogOpenTask(true);
                    handleSubtaskOptionsClose();
                  }}
                >
                  <DeleteIcon sx={{ fontSize: '16px', color: 'var(--danger-color, #b04632)' }} />
                  Excluir tarefa
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--text-primary, #172b4d)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    let subtaskText = '';
                    for (const taskId in subTasks) {
                      const found = (subTasks[taskId] || []).find(st => st.subtask_id === currentSubtaskId);
                      if (found) {
                        subtaskText = found.subtask_text;
                        break;
                      }
                    }
                    setEditingSubtaskId(currentSubtaskId);
                    setEditingSubtaskText(subtaskText);
                    setIsEditingSubTask(true);
                    handleSubtaskOptionsClose();
                  }}
                >
                  <EditIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                  Editar subtarefa
                </Typography>
                <Typography
                  sx={{
                    px: 2,
                    py: 1.5,
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'var(--danger-color, #b04632)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      backgroundColor: 'var(--danger-bg, #ffebe6)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={() => openDeleteSubtask(subTaskToDelete)}
                >
                  <DeleteIcon sx={{ fontSize: '16px', color: 'var(--danger-color, #b04632)' }} />
                  Excluir subtarefa
                </Typography>
              </>
            )}
          </Box>
        </Popover>

        <ConfirmationDialog
          open={deleteSubtask}
          onClose={() => setDeleteSubtask(false)}
          onConfirm={() => {
            if (subTaskToDelete) {
              handleDeleteSubtask(subTaskToDelete.task_id, subTaskToDelete.subtask_id);
            }
            setSubTaskToDelete(null);
          }}
          title="Confirmar Exclusão"
          message={
            <>
              Tem certeza que deseja excluir a subtarefa: <strong>{subTaskToDelete?.subtask_text}</strong> ?
            </>
          }
        />
      </Box>
      
      {alert.show &&
        ReactDOM.createPortal(
          <div className="alert-container-card custom">
            <Alerts
              severity={alert.severity}
              message={alert.message}
              onClose={() => setAlert({ show: false, severity: '', message: '' })}
            />
          </div>,
          document.body
        )}
    </>
  );
}

function getDateColorClass(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const today = new Date();
  
  if (date.toDateString() === today.toDateString()) return 'due-today';
  if (date < today) return 'overdue';
  return 'upcoming';
}